export var ComponentMode;
(function (ComponentMode) {
    ComponentMode[ComponentMode["Abstract"] = 0] = "Abstract";
    ComponentMode[ComponentMode["Preview"] = 1] = "Preview";
    ComponentMode[ComponentMode["Runtime"] = 2] = "Runtime";
})(ComponentMode || (ComponentMode = {}));
//# sourceMappingURL=isite.js.map